import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser';
import { AppConfig } from '../../shared/config/app-config';
import { EventTrackingServiceProvider } from './event-tracking.service';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CustomerIOEventTrackingService implements EventTrackingServiceProvider {
    private analytics: AnalyticsBrowser;
    identified = false;
    constructor(private config: AppConfig) {
        this.analytics = AnalyticsBrowser.load({
            cdnURL: config.CUSTOMER_IO_CDN_URL,
            writeKey: config.CUSTOMER_IO_WRITE_KEY,
        });
    }

    track(eventName: string, eventData: Record<string, any>) {
        if (!this.identified) {
            this.analytics.identify(eventData?.user_name);
            this.identified = true;
        }
        this.analytics.track(eventName, eventData);
    }
}
